import { Component } from "react";
import { BoardTheming } from './BoardTheming';
import { getRandomSmallKey, isDefined } from '@Utils/Micro';
import { WebNode } from '@API/WebNode';
import { WebNodeStatus } from '@API/WebNodeTypes';
import "./BoardWSStatus.less";
// ================================================================================================
export interface WSStatusProps {
    NodeKey: string;
}
// -----------------------------------------------------------------------------------------------
export interface WSStatusState {
    status: WebNodeStatus;
    iconKey: string;
}
// -----------------------------------------------------------------------------------------------
export class WSStatus extends Component<WSStatusProps, WSStatusState>{
    constructor(props: WSStatusProps) {
        super(props);

        let webNode = WebNode.GetInstanceKey(this.props.NodeKey);
        this.state = {
            status: (isDefined(webNode)) ? webNode.Status : WebNodeStatus.Disconnected,
            iconKey: getRandomSmallKey()
        }
    }
    // -------------------------------------------------------------------------------------------
    private updateStatus = (status: WebNodeStatus) => this.setState({ status });
    // -------------------------------------------------------------------------------------------
    private respStatus = (status: number) => {
        // Forse new icon :)
        this.setState({ iconKey: getRandomSmallKey() });
    };
    // -------------------------------------------------------------------------------------------
    componentDidMount() {
        // Register the subscribe for status update
        let webNode = WebNode.GetInstanceKey(this.props.NodeKey);
        if (isDefined(webNode)) {
            webNode.onStatusUpdate.subscribe(this.updateStatus);
            webNode.onGenericRsp.subscribe(this.respStatus);
        }
    }
    // -------------------------------------------------------------------------------------------
    componentWillUnmount() {
        // UnRegister the subscribe for status update
        let webNode = WebNode.GetInstanceKey(this.props.NodeKey);
        if (isDefined(webNode)) {
            webNode.onStatusUpdate.unsubscribe(this.updateStatus);
            webNode.onGenericRsp.unsubscribe(this.respStatus);
        }
    }
    // -------------------------------------------------------------------------------------------
    render() {
        let theme = BoardTheming.GetTheme(this.props.NodeKey);
        let webNode = WebNode.GetInstanceKey(this.props.NodeKey);
        if (isDefined(webNode) && webNode.Status == WebNodeStatus.Connected)
            return <div
                key={this.state.iconKey}
                className="yodiwo-avatar"
            >
                <i className="fas fa-wifi" style={{ color: theme.boardToolbar.style.fontColor }} />
            </div>

        return <div
            key="wsnode-status-error"
            className="yodiwo-avatar"
            style={{ backgroundColor: "#f44336", color: "white", width: 30, height: 30, fontSize: 16 }}
        >
            <i className="fas fa-wifi-slash" />
        </div>
    }
    // -------------------------------------------------------------------------------------------
}